const buildVersion = process.env.APP_BUILD_VERSION || '1.0.0';

module.exports = {
  buildVersion,
  port: process.env.SF_MOBILE_PORT || 3000,
  trustProxy: process.env.TRUST_PROXY || 'loopback',
  api: {
    clientUrl: process.env.API_CLIENT_URL || 'https://www.hepsiburada.com/api/v1',
    serverUrl: process.env.API_SERVER_URL || 'http://pwa-varnish-service.pwavarnish/api/v1',
  },
  analytics: {
    googleTrackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X
  },
  auth: {
    jwt: {secret: process.env.JWT_SECRET || 'hepsiburada.com'},
  },
  baseUrl: 'https://www.hepsiburada.com',
  hydraHomepageUrl: 'https://hydra-home-api.hepsiburada.com',
  hydraUrlEngineUrl: 'https://hydra-url-engine.hepsiburada.com/api/v1',
  brandQueryApiUrl: 'https://brand-query-api.hepsiburada.com',
  recommendationApiUrl: 'https://recommendation.hepsiburada.com/api/v1',
  recommendationInternalApiUrl: 'http://recommendation-internal.hepsiburada.com/api/v1',
  stargateUrl: 'https://stargate.hepsiburada.com/converter',
  stargateServerUrl: 'http://stargatecacheservice.microservicevarnish/converter',
  moriaApi: {
    clientUrl: 'https://blackgate.hepsiburada.com/moriaapi',
    serverUrl: 'https://moria-api.hepsiburada.com'
  },
  shippingVoltranUrl: {
    clientUrl: 'https://shipping-voltran.hepsiburada.com',
    serverUrl: 'https://shipping-voltran.hepsiburada.com',
  },
  userContent: {
    clientUrl: 'https://usercontent.hepsiburada.com',
    serverUrl: 'http://usercontent-internal.hepsiburada.com'
  },
  checkoutUi: {
    clientUrl: 'https://checkout-ui.hepsiburada.com',
    serverUrl: 'https://checkout-ui-internal.hepsiburada.com'
  },
  askToSellerVoltranUrl: 'https://cst-phoenix-mfe.hepsiburada.com',
  customerVoltranGatewayApiUrl: 'https://customer-voltran-gw.hepsiburada.com/api',
  checkoutUrl: 'https://www.hepsiburada.com',
  checkoutUiUrl: 'https://checkout-ui-internal.hepsiburada.com',
  campaignApiUrl: 'https://obiwan-gw.hepsiburada.com/api',
  ecomApiUrl: 'https://ecom-gateway.hepsiburada.com',
  accountUrl: 'https://www.hepsiburada.com/ayagina-gelsin',
  arwenUrl: 'https://blackgate.hepsiburada.com/arwenapi',
  sfBaseUrl: 'https://www.hepsiburada.com',
  arfUrl: 'https://arf-user-interest.hepsiburada.com/api/v1',
  arfServerUrl: 'https://arf-user-interest-internal.hepsiburada.com/api/v1',
  converterUrl: 'https://converter.hepsiburada.com',
  loginUrl: 'http://www.hepsiburada.com',
  campaignVoltranUrl: 'https://campaign-ui.hepsiburada.com',
  voltranUrl: 'https://voltran.hepsiburada.com',
  voltranServerUrl: 'http://voltrancacheservice.microservicevarnish',
  voltranCommonJsUrl: 'https://images.hepsiburada.net/storefront/storefront/www/voltran-common/1.1.139/library.dll.js',
  cacVoltranUrl: 'https://cac-ui.hepsiburada.com',
  hepsiAdsVoltranUrl: 'https://hepsiads-ui.hepsiburada.com',
  loyaltyVoltranUrl: 'https://loyalty-voltran.hepsiburada.com',
  premiumVoltranUrl: 'https://payment-mfe.hepsiburada.com',
  hodorUrl: 'https://obiwan-gw.hepsiburada.com',
  hydraVoltran: {
    serverUrl: 'https://hydra-voltran-internal.hepsiburada.com',
    clientUrl: 'https://hydra-voltran.hepsiburada.com',
  },
  hepsiAdsSponsoredBrandVoltranUrl: 'https://hepsiads-sponsor-ui-internal.hepsiburada.com',
  brandContentVoltranUrl: {
    clientUrl: 'https://brandcontent-external.hepsiburada.com',
    serverUrl: 'http://brandcontent-internal.hepsiburada.com'
  },
  sardesInstallmentVoltranUrl: 'https://sardes-microfrontend-installment.hepsiburada.com',
  merchantContentVoltranUrl:{
    serverUrl:"http://merchantcontent-internal.hepsiburada.com",
    clientUrl:"https://merchantcontent-external.hepsiburada.com",
  },
  merchantQueryServiceApiUrl:"http://merchant-query-service-internal.hepsiburada.com/v1",
  merchantContentServiceApiUrl: "http://merchantcontent-api-internal.hepsiburada.com",
  sardesWalletVoltranUrl: 'https://cuzdanim-mfe.hepsiburada.com',
  shippingApiUrl: 'https://shipping-external.hepsiburada.com',
  trackId: '289941511384204',
  mediaUrl: `https://images.hepsiburada.net/storefront/storefront/www/storefront-pwa/${buildVersion}`,
  logLevel: 'warn',
  homePageStaticCampaignText: 'Günün Fırsatları',
  categoryPageStaticCampaignText: 'Günün Fırsatı',
  campaignText: `Efsanenin Yıldızları`,
  campaignTextOnProduct: 'Efsanenin Yıldızı',
  zipkinServerUrl: 'http://sf-metrics.hepsiburada.dmz:9411/api/v1/spans',
  zipkinSamplingRate: 0.1,
  mirrorUrl: 'https://mirror.hepsiburada.com',
  mirrorSfUrl: 'https://www.hepsiburada.com',
  mainCarouselPlaceholderRatio: 1.22,
  isCssClassNameObfuscationEnabled: true,
  isChunkFileNameHashEnabled: true,
  defaultTimeoutInMilliseconds: 1000 * 3,
  checkoutTimeoutInMilliseconds: 1000 * 6,
  navigationTimeoutInMilliseconds: 1000 * 20,
  hermesTimeoutInMilliseconds: 1000 * 10,
  installmentTimeoutInMilliseconds: 1000 * 10,
  arfClientTimeoutInMilliseconds: 1000,
  arfServerTimeoutInMilliseconds: 300,
  newrelicEnabled: true,
  internalCache: {
    defaultInternalCacheMilliseconds: 1000 * 60 * 5,
  },
  marketingBillboardType: 2,
  reduxDevToolEnabled: false,
  cosmosPrefix: 'sf',
  bundleAnalyzerStaticEnabled: false,
  hbusVersion: '3.8.67'
};
